import { defineMessages } from 'react-intl';

/** Copy is fixed and supplied by Health NZ. `{date}` is the last day of the
 *  current calendar month. */
export const healthNzMigrationModalMessages = defineMessages({
  heading: {
    defaultMessage: 'Your Health NZ email isn’t linked to the Health NZ team',
    id: '/2OxIZ8dg+',
    description:
      'Heading of the modal telling a solo user their Health NZ email must sit under the Health NZ enterprise agreement',
  },
  requirement: {
    defaultMessage:
      'Health NZ requires all accounts using a Health NZ email to sit under its managed enterprise agreement.',
    id: '+M8uaQjrJq',
    description: 'Explains why the account is affected',
  },
  personalUse: {
    defaultMessage:
      'If this account is for personal use, update your email now to keep it separate.',
    id: 'exd+eEz8bt',
    description: 'Tells the user how to opt out of the migration',
  },
  automaticMove: {
    defaultMessage:
      'If not, your account will move automatically to the Health NZ team on {date}. You’ll keep full access, and any paid subscription is refunded pro-rata.',
    id: 'gJVm/ZOAtN',
    description:
      'Explains what happens if the user takes no action, including the migration date',
  },
  retentionNote: {
    defaultMessage:
      'Note: Health NZ’s 14-day data retention policy will then apply, so ensure any clinical session is recorded on your appropriate EHR.',
    id: 'qpfRByl22v',
    description:
      'Own paragraph after the migration explanation — the data-retention consequence and what the clinician must do about it',
  },
  acknowledgement: {
    defaultMessage:
      'I understand my account will move to the Health NZ team on {date} if I don’t take action.',
    id: 'UwyRKQZcsA',
    description:
      'Acknowledgement sentence shown as body text directly above the buttons — not a button label',
  },
  updateEmail: {
    defaultMessage: 'Update email',
    id: 'vb/kUuhJmv',
    description: 'Primary button — opens Settings on the account email field',
  },
  acknowledge: {
    defaultMessage: 'I understand',
    id: '4NpWtWz7Mm',
    description: 'Secondary button — permanently dismisses the notice',
  },
  supportQuestion: {
    defaultMessage:
      'If you have any questions about this change, <link>contact our support team</link>.',
    id: 'l6XLlTyiXJ',
    description:
      'Sits under the body copy; the link opens the Intercom messenger rather than navigating',
  },
});
